import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';

const getUrl = ({ host, gatewayId }: { host: string; gatewayId: string }): string => {
  return `${host}/gateways/${gatewayId}/reboot`;
};

export const RebootGateway = async ({ host, token, gatewayId }: { host: string; token: string; gatewayId: string }): Promise<void> => {
  try {
    const url = getUrl({ host, gatewayId });

    const options: AxiosRequestConfig = {
      url,
      method: 'POST',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
    };

    (await axios(options)) as AxiosResponse<void>;
  } catch (error) {
    throw getErrorFormat(error);
  }
};
